export default {
	lang:'fr',
	download:{
		"download01":"Windows",
		"download02":"Mac",
		"download03":"iOS",
		"download04":"Androïde",
		"download05":"Télécharger maintenant",
		"download":"télécharger",
		"download2":"Mobile",
		"download3":"Scannez le code QR pour télécharger iOS/Android",
		"download4":"code QR",
		"download5":"Windows",
		"download6":"Prise en charge de Windows 10 64 bits et versions ultérieures",
		"download7":"macOS",
		"download8":"Prend en charge MacOS 10.14 et supérieur",
		"download9":"App Store",
		"download10":"Prend en charge MacOS 10.14 et supérieur",
		"download11":"Androïde",
		"download12":"Prise en charge d'Android 10.14 et supérieur",
	},
	home:{
		"home":"home page",
		"XiaobeiBigModel":"Xiaobei grand modèle",
		"AIcapability":"Capacités de l'IA",
		"Solution":"Solution",
		"ProductCenter":"Produit",
		"MediaCenter":"Médias",
		"AboutUs":"à propos de nous",
		"Login/Regis":"Connexion/Inscription",
		"home1":"Compétences de base",
		"home2":"Hotline du service client",
		"home3":"Numéro de contact",
		"home14":"L'autonomisation de l'IA, utilisant du matériel intelligent comme support, offre des capacités et des services complets",
		"home15":"Algorithme Jigsaw",
		"home16":"Reconnaissance OCR",
		"home17":"Intelligence artificielle",
		"home18":"Reconnaissance vocale",
		"home19":"Dictionnaire faisant autorité",
		"home20":"Traduction de texte",
		"home21":"Traduction de photos",
		"home22":"Questions et réponses générales",
		"home23":"Cours vidéo",
		"home24":"Grand modèle Xiaobei AI",
		"home25":"La technologie est la principale force productive",
		"home26":"Personnel technique",
		"home27":"Investissement en R&D",
		"home28":"Nombre de brevets",
		"home29":"(Pourcentage)",
		"home30":"(100 millions de yuans)",
		"home31":"(article)",
		"home32":"Solution",
		"home33":"Face aux besoins d'application de multiples scénarios tels que le bureau, l'éducation et la boîte de voiture, BeiBo fournit à ses clients des solutions uniques basées sur ses propres capacités de R&D et concepts de service.",
		"home34":"Solutions connexes",
		"home35":"Fonctionnalités des produits associés",
		"home36":"Services complets",
		"home37":"L'autonomisation de l'IA, utilisant du matériel intelligent comme support, offre des capacités et des services complets",
		"home38":"Recherche et développement",
		"home39":"Production",
		"home40":"Gestion de la qualité",
		"home41":"Support après-vente",
		"home42":"Équipe professionnelle de R&D en logiciels et matériel, avec de nombreuses années de capacités de R&D en OCR, reconnaissance vocale, traduction, IA et interaction homme-machine",
		"home43":"Usine source, chaîne d'approvisionnement stable, processus de production intelligent et strict",
		"home44":"Les inspecteurs de qualité vérifient chaque étape et introduisent le système de gestion ISO9001",
		"home45":"Mettre en place des équipes de support après-vente professionnelles au pays et à l'étranger pour fournir une réponse rapide, des solutions ciblées et un service personnalisé.",
		"home46":"Certification",
		"home47":"Plus de 100 brevets nationaux et étrangers",
		"home48":"Nouvelles",
		"home49":"Découvrez nos dernières actualités",
		"home50":"vérifier les détails",
		"home51":"Partenaires",
		"home52":"Concentrez-vous sur le marché du matériel d'intelligence artificielle et fournissez des services OEM/0DM professionnels",
		"home53":"Consultation de coopération",
		"home54":"Bureau intelligent",
		"home55":"Éducation intelligente",
		"home56":"Coffret de voiture intelligent",
		"home57":"Reconnaissance vocale",
		"home58":"Algorithme Jigsaw",
		"home59":"Reconnaissance OCR",
		"home60":"Synthèse vocale",
		"home61":"Traduction de texte",
		"home62":"Traduction d'images",
		"home63":"Traduction vocale",
		"home64":"Traitement du langage naturel",
		"home571":"Reconnaissance OCR",
		"home581":"Reconnaissance vocale ",
		"home591":"Traduction vocale",
		"home601":"Synthèse vocale",
		"home611":"Dictionnaire faisant autorité",
		"home621":"Cours généraux",
		"home631":"Questions et réponses générales",
		"home641":"Traitement du langage naturel",
		"home572":"Reconnaissance vocale",
		"home582":"Synthèse vocale ",
		"home592":"Traduction vocale",
		"home602":"Traitement du langage naturel",
		"home603":"Pas plus",
		
	},
	consult:{
		"tilte":"Nous vous fournirons de tout cœur une gamme complète de services de coopération commerciale",
		"subtilte":"Veuillez laisser vos coordonnées et nous vous contacterons dans les plus brefs délais",
		"name":"Veuillez entrer votre nom",
		"phone":"Veuillez entrer votre numéro de téléphone",
		"mailbox":"Veuillez entrer votre email",
		"mailboxerr":"Erreur de format de courrier électronique",
		"company":"Veuillez entrer votre entreprise",
		"desc":"Veuillez saisir vos besoins",
		"but":"Confirmer la soumission",
		"region":"Chine",
		"select":"Veuillez sélectionner",
		"submitSuccess":"Soumettre avec succès",
		"submitError":"La soumission a échoué",
	},
	ProDetails:{
		"ProDetails1":"Processus de personnalisation",
		"ProDetails2":"Concentrez-vous sur le marché du matériel d'intelligence artificielle et fournissez des services OEM/0DM professionnels",
	},
	aiCapacity:{
		"aiMode1":"Capacités de l'IA",
		"aiMode2":"En nous appuyant sur des technologies telles que le Big Data, les graphes de connaissances, l’apprentissage automatique et la linguistique, nous continuons d’innover et de nous concentrer sur la recherche de technologies de base de l’IA et la mise en œuvre d’applications matérielles intelligentes.",
		"aiMode3":"Consultation de coopération",
		"aiMode4":"Compétences de base",
		"aiMode5":"L'autonomisation de l'IA, utilisant du matériel intelligent comme support, offre des capacités et des services complets",
		"aiMode6":"Algorithme Jigsaw",
		"aiMode7":"Fusionnez de petites images fragmentées en grandes images pour la reconnaissance, prenant en charge plus de 50 langues",
		"aiMode8":"Reconnaissance OCR",
		"aiMode9":"Extrayez du texte grâce au traitement d'images et à la reconnaissance de formes. Plus de 50 langues sont disponibles.",
		"aiMode10":"Reconnaissance vocale",
		"aiMode11":"Reconnaît avec précision les fichiers audio longs et courts en texte. Prise en charge de plus de 130 langues.",
		"aiMode12":"Synthèse vocale",
		"aiMode13":"Convertissez du texte en voix humaine naturelle et fluide. Plus de 130 langues sont disponibles.",
		"aiMode14":"Traduction de texte",
		"aiMode15":"Convertissez le texte de la langue cible vers la langue spécifiée. Plus de 130 langues sont prises en charge.",
		"aiMode16":"Traduction d'images",
		"aiMode17":"Reconnaissance et traduction de textes et d'images. Plus de 130 langues disponibles.",
		"aiMode18":"Traduction vocale",
		"aiMode19":"Reconnaît et traduit avec précision les fichiers audio longs et courts. Plus de 130 langues sont disponibles.",
		"aiMode20":"Traitement du langage naturel",
		"aiMode21":"Sur la base du Big Data, des connaissances et des technologies linguistiques, des applications telles que les questions-réponses et le dialogue peuvent être réalisées.",
		"aiMode22":"Autorité du dictionnaire",
		"aiMode23":"Coopérer en profondeur avec les institutions faisant autorité pour fournir des dictionnaires authentiques tels qu'Oxford, Longman et diverses langues minoritaires",
		"aiMode24":"Cours vidéo",
		"aiMode25":"Cours vidéo complets, manuels mis à jour simultanément, adaptés à la prévisualisation et à la révision",
		"aiMode26":"Questions et réponses générales",
		"aiMode27":"Répondez aux questions et interprétez les questions dans toutes les matières, apprenez par analogie et améliorez l'efficacité de l'apprentissage",
		"aiMode28":"Grand modèle Xiaobei AI",
		"aiMode29":"Interaction multimodale",
		"aiMode30":"Interaction multimodale texte, voix et vidéo",
		"aiMode31":"Capacité de codage",
		"aiMode32":"Génération de code, interprétation, débogage, test",
		"aiMode33":"Génération de texte",
		"aiMode34":"Génération d'essais, marketing, communiqués de presse, etc.",
		"aiMode35":"Médecine générale",
		"aiMode36":"Élaboration de questions et résolution de problèmes pour toutes les matières",
		"aiMode37":"Compréhension du langage",
		"aiMode38":"Extraction abstraite, vérification grammaticale, analyse des sentiments",
		"aiMode39":"Anecdotes",
		"aiMode40":"Connaissance de la vie, du travail, de la médecine et de l'histoire",
		"aiMode41":"Raisonnement logique",
		"aiMode42":"Pensée, science, raisonnement de bon sens",
		"aiMode43":"Multilingue",
		"aiMode44":"Prend en charge l'interaction dans plus de 100 langues",
		"aiMode45":"Avantages techniques",
		"aiMode46":"200 millions de corpus précis",
		"aiMode47":"Largement utilisé dans les bureaux intelligents, l'éducation intelligente, les boîtes de voiture intelligentes",
		"aiMode48":"Technologie collaborative mondiale",
		"aiMode49":"Latence ultra-faible, sûr et stable, planification intelligente, lien stable",
		"aiMode50":"Système de cryptage de sécurité",
		"aiMode51":"Système de cryptage quadridimensionnel de données cloud-end-end leader international, cryptage complet du processus",
	},
	aiMode:{
		"aiMode1":"Capacités de l'IA",
		"aiMode2":"En nous appuyant sur des technologies telles que le Big Data, les graphes de connaissances, l’apprentissage automatique et la linguistique, nous continuons d’innover et de nous concentrer sur la recherche de technologies de base de l’IA et la mise en œuvre d’applications matérielles intelligentes.",
		"aiMode3":"Consultation de coopération",
		"aiMode4":"Compétences de base",
		"aiMode5":"L'autonomisation de l'IA, utilisant du matériel intelligent comme support, offre des capacités et des services complets",
		"aiMode6":"Algorithme Jigsaw",
		"aiMode7":"Fusionnez de petites images fragmentées en grandes images pour la reconnaissance, prenant en charge plus de 50 langues",
		"aiMode8":"Reconnaissance OCR",
		"aiMode9":"Extrayez du texte grâce au traitement d'images et à la reconnaissance de formes. Plus de 50 langues sont disponibles.",
		"aiMode10":"Reconnaissance vocale",
		"aiMode11":"Reconnaît avec précision les fichiers audio longs et courts en texte. Prise en charge de plus de 130 langues.",
		"aiMode12":"Synthèse vocale",
		"aiMode13":"Convertissez du texte en voix humaine naturelle et fluide. Plus de 130 langues sont disponibles.",
		"aiMode14":"Traduction de texte",
		"aiMode15":"Convertissez le texte de la langue cible vers la langue spécifiée. Plus de 130 langues sont prises en charge.",
		"aiMode16":"Traduction d'images",
		"aiMode17":"Reconnaissance et traduction de textes et d'images. Plus de 130 langues disponibles.",
		"aiMode18":"Traduction vocale",
		"aiMode19":"Reconnaît et traduit avec précision les fichiers audio longs et courts. Plus de 130 langues sont disponibles.",
		"aiMode20":"Traitement du langage naturel",
		"aiMode21":"Réaliser des questions-réponses, des dialogues et d'autres applications basées sur le big data, la connaissance et la compréhension des technologies linguistiques",
		"aiMode22":"Autorité du dictionnaire",
		"aiMode23":"Coopérer en profondeur avec les institutions faisant autorité pour fournir des dictionnaires authentiques tels qu'Oxford, Longman et diverses langues minoritaires",
		"aiMode24":"Cours vidéo",
		"aiMode25":"Cours vidéo complets, manuels mis à jour simultanément, adaptés à la prévisualisation et à la révision",
		"aiMode26":"Questions et réponses générales",
		"aiMode27":"Répondez aux questions et interprétez les questions dans toutes les matières, apprenez par analogie et améliorez l'efficacité de l'apprentissage",
		"aiMode28":"Grand modèle Xiaobei AI",
		"aiMode29":"Interaction multimodale",
		"aiMode30":"Interaction multimodale texte, voix et vidéo",
		"aiMode31":"Capacité de codage",
		"aiMode32":"Génération de code, interprétation, débogage, test",
		"aiMode33":"Génération de texte",
		"aiMode34":"Composition, marketing, génération de communiqués de presse, etc.",
		"aiMode35":"Médecine générale",
		"aiMode36":"Élaboration de questions et résolution de problèmes pour toutes les matières",
		"aiMode37":"Compréhension du langage",
		"aiMode38":"Extraction abstraite, vérification grammaticale, analyse des sentiments",
		"aiMode39":"Anecdotes",
		"aiMode40":"Connaissance de la vie, du travail, de la médecine et de l'histoire",
	},
	Product:{
		"Product1":"Centre de produits",
		"Product2":"Produits intelligents pour le bureau, l'éducation et les véhicules, prenant en charge la commande et la personnalisation des fonctions",
		"Product3":"Consultation de coopération",
	},
	medium:{
		"medium1":"Centre des médias",
		"medium2":"Les dernières nouvelles de BeiBo, veuillez voir ici",
		"medium3":"Consultation de coopération",
	},
	about:{
		"about1":"En savoir plus sur BeiBo",
		"about2":"Fournisseur de solutions matérielles intelligentes pour le bureau, l'éducation, les boîtes de voiture, etc.",
		"about3":"Consultation de coopération",
		"about4":"Profil de l'entreprise",
		"about5":"Certification",
		"about6":"Plus de 100 brevets nationaux et étrangers",
		"about7":"Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"about8":"Fondée en 2015 et basée à Shenzhen, le centre de « fabrication intelligente » de Chine, BeiBo Intelligent est une entreprise nationale de haute technologie et une entreprise spécialisée et innovante avec une vision tournée vers l'avenir et un esprit d'innovation.",
		"about9":"L'entreprise se concentre sur le segment vertical de la voix IA et dispose d'excellentes capacités de R&D en logiciels et matériels d'IA. Elle optimise le matériel d'IA en exportant des technologies telles que la voix IA, la traduction IA, l'OCR IA, l'interaction homme-véhicule IA et le cloud IA. L'entreprise développe son propre modèle d'IA de traduction vocale, intègre les dernières technologies d'IA multimodale et AIGC, et fournit des solutions technologiques complètes de voix IA à des clients de différents secteurs, basées sur la R&D et la conception de plateformes de puces et de solutions matérielles. Dans les secteurs de l'éducation, du gouvernement, des entreprises et de l'armée, l'entreprise dispose de solutions industrielles matures ; côté grand public, les ventes annuelles de matériel d'IA, comme les traducteurs IA, les enregistreurs vocaux IA, les scanners IA et les boîtiers de commande IA, dépassent le million d'unités. L'entreprise collabore avec de nombreux partenaires stratégiques au Japon, en Europe, aux États-Unis et dans d'autres pays et régions pour aider les utilisateurs à surmonter les barrières linguistiques, et est un fournisseur mondial de premier plan de solutions de technologie vocale IA.",
		"about10":"",
	},
	footer:{
		"AboutUs":"à propos de nous",
		"CollaborativeConsulting":"Consultation de coopération",
		"Businesscooperation":"Coopération commerciale",
		"phone":"Veuillez entrer votre numéro de téléphone",
		"phone2":"+86 13660736734",
		"phone3":"hangou@szbbzn.com",
		"tel":"0755 27189290",
		"address":"Salle 201, bâtiment F, zone industrielle de Yuanfen, communauté de Taoyuan, rue Dalang, district de Longhua, Shenzhen",
		"copyright":"Droits d'auteur © Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"icp":"Numéro ICP du Guangdong 2024241358-1",
		"footer2":"Bienvenue pour vous inscrire",
		"footer3":"Vous avez déjà un compte ?",
		"footer4":"Veuillez vous connecter",
	},
	login:{
		"login1":"Connexion par mot de passe",
		"login2":"Connexion par SMS",
		"loginTab3":"Connexion par e-mail",
		"login3":"Mail",
		"login4":"Mot de passe de connexion",
		"login5":"Numéro de téléphone",
		"login6":"Veuillez sélectionner",
		"login7":"Code de vérification mobile",
		"login8":"Se connecter",
		"login9":"oublier le mot de passe",
		"login10":"registre",
		"login11":"En vous connectant, vous acceptez",
		"login12":"Contrat de service",
		"login13":"politique de confidentialité",
		"login14":"Obtenir",
		"login15":"Chine",
		"login16":"Veuillez entrer votre numéro de compte",
		"login17":"Veuillez entrer votre mot de passe",
		"login18":"Connexion réussie !",
		"login19":"Veuillez entrer le code de vérification !",
		"login20":"Envoyé avec succès!",
		"login21":"et",
		"login22":"Disque cloud d'enregistreur vocal",
		"login23":"Mon écriture",
		"login24":"Ma conversation",
		"login25":"Sécurité du compte",
		"login26":"Se déconnecter",
		"login27":"Récupérer le mot de passe par e-mail",
		"login28":"Mail",
		"login29":"Code de vérification de l'e-mail",
		"login30":"Définir un mot de passe de connexion (6 à 16 caractères)",
		"login31":"Saisissez à nouveau votre mot de passe de connexion",
		"login32":"soumettre",
		"login33":"Retour à la connexion",
		"login34":"Modification réussie !",
	},
	register:{
		"register1":"Numéro de téléphone",
		"register2":"Veuillez entrer votre numéro de téléphone",
		"register3":"Veuillez sélectionner",
		"register4":"Code de vérification mobile",
		"register5":"Définir le mot de passe",
		"register6":"Veuillez saisir le code de vérification",
		"register7":"6 à 16 caractères",
		"register8":"Confirmation du mot de passe",
		"register9":"Mail",
		"register10":"Veuillez entrer votre adresse e-mail",
		"register11":"Code de vérification de l'e-mail",
		"register12":"Veuillez saisir le code de vérification",
		"register13":"J'ai lu et j'accepte",
		"register14":"Veuillez lire et cocher la case qui accepte l'accord",
		"register15":"Le format du numéro de téléphone est incorrect/le numéro de téléphone a été enregistré",
		"register16":"Erreur de code de vérification mobile",
		"register17":"Veuillez saisir votre adresse e-mail / Le format de l'adresse e-mail est incorrect",
		"register18":"Erreur de format de courrier électronique",
		"register19":"Erreur de code de vérification de l'e-mail",
		"register20":"Veuillez définir le mot de passe sur 6 à 16 caractères",
		"register21":"Erreur de format de mot de passe",
		"register22":"Les mots de passe saisis deux fois ne correspondent pas. Veuillez les saisir à nouveau.",
		"register23":"Veuillez entrer votre mot de passe",
		"register24":"Inscription réussie !",
		"register25":"Erreur de code de vérification",
		
	},
	recorder:{
		"recorder1":"Disque cloud enregistreur vocal",
		"recorder2":"Capacité de l'espace cloud",
		"recorder3":"document",
		"recorder331":"Corbeille",
		"recorder332":"Tout effacer",
		"recorder4":"nom",
		"recorder5":"Durée de l'audio",
		"recorder6":"Taille du fichier",
		"recorder7":"Temps de création",
		"recorder8":"fonctionner",
		"recorder9":"Description de l'espace nuageux",
		"recorder10":"document",
		"recorder11":"Fichier OCR",
		"recorder12":"1. À quoi sert l’espace cloud ?",
		"recorder13":"Après l'enregistrement, vous pouvez télécharger les fichiers audio et de transcription sur le cloud. Même sans l'enregistreur, vous pouvez accéder au cloud pour visionner l'audio.",
		"recorder14":"2. Comment télécharger vers l'espace cloud ?",
		"recorder15":"Accédez à [Mes fichiers] sur l'enregistreur, sélectionnez le fichier cible et appuyez longuement pour afficher les options, puis cliquez sur « Télécharger » pour télécharger le fichier sur l'espace cloud.",
		"recorder16":"3. Comment visualiser/gérer les fichiers de l'espace cloud ?",
		"recorder17":"Connectez-vous au site officiel de BeiBo, sélectionnez « My-Recorder Cloud Disk » et vous pourrez consulter les fichiers d'enregistrement téléchargés. Vous pouvez sélectionner le fichier cible à télécharger, supprimer, etc. Vous pouvez également nettoyer l'espace de stockage cloud en supprimant les fichiers.",
		"recorder18":"Non transcrit",
		"recorder19":"Voir le résumé",
		"recorder20":"Conférencier",
		"recorder21":"Modifier le nom du locuteur",
		"recorder22":"Bien sûr",
		"recorder23":"télécharger",
		"recorder24":"Télécharger le contenu :",
		"recorder25":"Paramètres de téléchargement :",
		"recorder26":"Afficher le haut-parleur",
		"recorder27":"Annuler",
		"recorder28":"Partage de liens",
		"recorder29":"Toute personne recevant le lien peut y accéder. Seule la lecture est autorisée. Le lien est valable 7 jours.",
		"recorder30":"Copier le lien",
		"recorder31":"Numérisez et visualisez rapidement",
		"recorder32":"Organisation intelligente",
		"recorder33":"Faire la différence entre les locuteurs",
		"recorder34":"Distinguer intelligemment le texte transcrit en fonction du rôle du locuteur",
		"recorder35":"Régularisation intelligente du langage parlé",
		"recorder36":"Filtrer automatiquement les particules modales, les mots répétés et les mots de pause",
		"recorder37":"Filtrage non vocal",
		"recorder38":"Ignorer automatiquement l'audio sans voix ni bruit pendant la lecture",
		"recorder39":"Veuillez sélectionner",
		"recorder40":"document",
		"recorder41":"Audio",
		"recorder42":"Documents + Audio",
		"recorder43":"indice",
		"recorder44":"Cette opération supprimera des fichiers, souhaitez-vous continuer ?",
		"recorder441":"Cette opération supprimera tous les fichiers, voulez-vous continuer ?",
		"recorder45":"Bien sûr",
		"recorder46":"Annuler",
		"recorder47":"Supprimé avec succès !",
		"recorder48":"Non supprimé",
		"recorder49":"Pas encore de tags",
		"recorder50":"Économie...",
		"recorder51":"Corbeille",
	},
	personal:{
		"personal1":"Paramètres du compte",
		"personal2":"informations personnelles",
		"personal3":"avatar",
		"personal4":"Télécharger des fichiers",
		"personal5":"Prise en charge des styles JPG, JPEG, GIF, PNG, prise en charge des images jusqu'à 2 M",
		"personal6":"Surnom",
		"personal7":"Veuillez entrer votre pseudo",
		"personal8":"genre",
		"personal9":"Messieurs",
		"personal10":"Manquer",
		"personal11":"Confidentialité",
		"personal12":"Anniversaire",
		"personal13":"Veuillez sélectionner votre date de naissance",
		"personal14":"Profession",
		"personal15":"Veuillez sélectionner votre profession",
		"personal16":"Veuillez indiquer votre profession (facultatif)",
		"personal17":"nation",
		"personal18":"Veuillez sélectionner votre pays",
		"personal19":"garder",
		"personal20":"informations personnelles",
		"personal21":"Sécurité du compte",
		"personal22":"Prend uniquement en charge les images jusqu'à 2 M",
		"personal23":"Téléchargement réussi !",
		"personal24":"Modification réussie !",
		"personal25":"Sécurité du compte",
		"personal26":"Mot de passe de connexion",
		"personal27":"Réviser",
		"personal28":"E-mail",
		"personal29":"remplacer",
		"personal30":"Annulation de compte",
		"personal32":"Êtes-vous sûr de vouloir annuler votre compte ?",
		"personal33":"Après vous être déconnecté, tout le contenu de votre compte sera effacé, veuillez donc procéder avec prudence.",
		"personal34":"Annuler",
		"personal35":"Bien sûr",
		"personal36":"Authentification",
		"personal37":"Pour confirmer que c'est bien vous qui faites cela, veuillez compléter la vérification d'identité via le code de vérification par e-mail",
		"personal38":"Mail",
		"personal39":"Le code de vérification",
		"personal40":"Veuillez saisir le code de vérification",
		"personal41":"Prochaine étape",
		"personal42":"Configurer une nouvelle boîte aux lettres",
		"personal43":"Mail",
		"personal44":"Veuillez saisir une nouvelle adresse e-mail",
		"personal45":"Le code de vérification",
		"personal46":"Veuillez saisir le code de vérification",
		"personal47":"Bien sûr",
		"personal48":"Définir un nouveau mot de passe de connexion",
		"personal49":"Nouveau mot de passe de connexion",
		"personal50":"Veuillez entrer un nouveau mot de passe",
		"personal51":"Confirmer le nouveau mot de passe",
		"personal52":"Veuillez saisir à nouveau votre nouveau mot de passe",
		"personal53":"Bien sûr",
		"personal54":"Obtenir",
		"personal55":"Erreur de format de courrier électronique",
		"personal56":"Remplacement réussi !",
		"personal57":"Veuillez définir le mot de passe sur 6 à 16 caractères",
		"personal58":"Les mots de passe que vous avez saisis deux fois ne correspondent pas",
		"personal59":"Modification réussie !",
		"personal60":"Déconnexion réussie !",
	}
}